import { Component, ElementRef } from '@angular/core';
import { ScrollService } from '../splash-service';

@Component({
    selector: 'app-landing-page',
    templateUrl: './landing-page.component.html',
    styleUrls: ['./landing-page.component.scss'],
})
export class LandingPageComponent {
    constructor(private scrollService: ScrollService, private elementRef: ElementRef) {}

    ngOnInit() {
      this.scrollService.scrollEvent$.subscribe(componentId => {
        const component = this.elementRef.nativeElement.querySelector(`#${componentId}`);
        let yOffset =  350;
        if(componentId !== 'Contact'){
           yOffset = -100;
        }
        const yCoordinate = component.getBoundingClientRect().top + window.pageYOffset + yOffset;
        if (component) {
          window.scrollTo({ top: yCoordinate, behavior: 'smooth', });
        }
      });
    }
}
